import { ref } from 'vue';
import { Role } from '@/features/Clients';

const invalidRoles = ref<Map<Role, boolean>>(new Map());
const lastProfession = ref<Map<Role, string>>(new Map());

export const useProfessionValidation = () => {
  const addInvalidRole = (role: Role) => invalidRoles.value.set(role, true);

  const removeRole = (role: Role) => invalidRoles.value.delete(role);

  const setLastProfession = (role: Role, query: string) =>
    lastProfession.value.set(role, query);
  const getLastProfession = (role: Role) => lastProfession.value.get(role);

  return {
    invalidRoles,
    addInvalidRole,
    removeRole,
    setLastProfession,
    getLastProfession,
  };
};
